import React, { useEffect, useState } from 'react'
import { KTIcon } from '../../../../_metronic/helpers'
import { useAuth } from '../../auth'
import { useAppSelector } from '../../../../redux/hooks'
import {
  getCTXRStatus,
  getCTXRStatusGlobal,
  getCTXRstatus,
  getCTXRstatusGlobal,
} from './request/request'
import { Modal, Tooltip, OverlayTrigger } from 'react-bootstrap'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import './styles.css';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import ImportExportIcon from '@mui/icons-material/ImportExport';
import styles from './cloudStatusTable.module.scss'; // Reutilizando el mismo estilo

type Props = {
  className: string
}

type StatusType = {
  id: string
  name: string
  lastupdate: string
  region: string
  description: string
  version: string | null
  metadata: Record<string, any> | null
}

const TablesWidget6: React.FC<Props> = ({ className }) => {
  const { currentUser } = useAuth()

  const Id = useAppSelector((state) => state.SuscriptionSlice.id) as number
  const Type = useAppSelector((state) => state.CloudSlice.Type)
  const tenant = useAppSelector((state) => state.TenantSlice.id) as number
  const nameregion = useAppSelector((state) => state.RegionSlice.name)

  const [statusCTX, setstatusCTX] = useState<StatusType[]>([])
  const [showModal, setShowModal] = useState(false)
  const [selectedMetadata, setSelectedMetadata] = useState<Record<string, any> | null>(null)
  const [selectedName, setSelectedName] = useState<string>('')
  const [copiedKey, setCopiedKey] = useState<string | null>(null)

  // Estados para búsqueda, paginación, filtrado por columna y ordenación
  const [searchTerm, setSearchTerm] = useState("");
  const [searchColumn, setSearchColumn] = useState("All");

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);

  const [sortColumn, setSortColumn] = useState<string>("");
  const [sortDirection, setSortDirection] = useState<'asc' | 'desc'>('asc');

  const handleSort = (column: string) => {
    if (sortColumn === column) {
      setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc')
    } else {
      setSortColumn(column)
      setSortDirection('asc')
    }
  }

  const getSortIcon = (col: string) => {
    if (sortColumn === col) {
      return sortDirection === 'asc'
        ? <KeyboardArrowUpIcon className={styles['sort-icon']} />
        : <KeyboardArrowDownIcon className={styles['sort-icon']} />;
    } else {
      return <ImportExportIcon className={styles['sort-icon']} style={{ opacity: 0.7 }} />;
    }
  }

  // Función para filtrar datos por columna seleccionada y término de búsqueda
  function applySearch(data: StatusType[]) {
    if (!searchTerm) return data;
    const lowerTerm = searchTerm.toLowerCase();

    return data.filter(d => {
      const matchesAll = (
        d.name.toLowerCase().includes(lowerTerm) ||
        d.description?.toLowerCase().includes(lowerTerm) ||
        d.region?.toLowerCase().includes(lowerTerm) ||
        d.lastupdate?.toLowerCase().includes(lowerTerm) || // Si interpretamos lastupdate como "status"
        (d.version?.toLowerCase().includes(lowerTerm) ?? false)
      );

      if (searchColumn === 'All') {
        return matchesAll;
      } else {
        let val = '';
        switch (searchColumn) {
          case 'name':
            val = d.name?.toLowerCase() || '';
            break;
          case 'description':
            val = d.description?.toLowerCase() || '';
            break;
          case 'region':
            val = d.region?.toLowerCase() || '';
            break;
          case 'status':
            val = d.lastupdate?.toLowerCase() || '';
            break;
          case 'version':
            val = d.version?.toLowerCase() || '';
            break;
          default:
            val = '';
        }
        return val.includes(lowerTerm);
      }
    });
  }

  // Función para ordenar datos por la columna y dirección seleccionada
  function applySort(data: StatusType[]) {
    if (!sortColumn) return data
    const sorted = [...data].sort((a, b) => {
      const valA = getValueForSort(a, sortColumn);
      const valB = getValueForSort(b, sortColumn);

      if (valA < valB) return sortDirection === 'asc' ? -1 : 1
      if (valA > valB) return sortDirection === 'asc' ? 1 : -1
      return 0
    })
    return sorted
  }

  // Función auxiliar para obtener el valor correcto según la columna a ordenar
  const getValueForSort = (item: StatusType, column: string): string => {
    switch (column) {
      case 'name': return item.name?.toLowerCase() || '';
      case 'description': return item.description?.toLowerCase() || '';
      case 'region': return item.region?.toLowerCase() || '';
      case 'status': return item.lastupdate?.toLowerCase() || '';
      case 'version': return item.version?.toLowerCase() || '';
      default: return '';
    }
  }

  const filteredData = applySort(applySearch(statusCTX));

  const totalItems = filteredData.length;
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const paginatedData = filteredData.slice(startIndex, endIndex);

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1);
  };

  const handlePageChange = (page: number) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const handleVersionClick = (metadata: Record<string, any> | null, name: string) => {
    if (metadata) {
      setSelectedMetadata(metadata)
      setSelectedName(name)
      setShowModal(true)
    }
  }

  const handleCloseModal = () => {
    setShowModal(false)
    setSelectedMetadata(null)
    setSelectedName('')
    setCopiedKey(null)
  }

  const handleCopy = (value: string, key: string) => {
    setCopiedKey(key)
    setTimeout(() => {
      setCopiedKey(null)
    }, 2000)
  }

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (
          Id &&
          typeof Id === 'number' &&
          ![0, -1].includes(Id) &&
          Type !== 'CloudGlobal' &&
          tenant === 0
        ) {
          const response = await getCTXRStatus(Id, Type, nameregion)
          if (response.data && response.data.error === 'suscriptionId error') {
            setstatusCTX([])
          } else {
            setstatusCTX(response.data)
          }
        } else if (
          Id &&
          typeof Id === 'number' &&
          ![0, -1].includes(Id) &&
          Type !== 'CloudGlobal' &&
          tenant !== 0 &&
          currentUser?.ListPermiso?.includes('CTXR.GeneralStatus')
        ) {
          const response = await getCTXRStatusGlobal(Id, tenant, Type, nameregion)
          if (response.data && response.data.error === 'suscriptionId error') {
            setstatusCTX([])
          } else {
            setstatusCTX(response.data)
          }
        } else if (
          Id === -1 &&
          tenant === 0 &&
          currentUser?.ListPermiso?.includes('CTXR.GeneralStatus')
        ) {
          const response = await getCTXRstatus(-1)
          if (response.data && response.data.error === 'suscriptionId error') {
            setstatusCTX([])
          } else {
            setstatusCTX(response.data)
          }
        } else if (
          Id === -1 &&
          tenant !== 0 &&
          currentUser?.ListPermiso?.includes('CTXR.GeneralStatus')
        ) {
          const response = await getCTXRstatusGlobal(-1, tenant)
          if (response.data && response.data.error === 'suscriptionId error') {
            setstatusCTX([])
          } else {
            setstatusCTX(response.data)
          }
        }
      } catch (error: any) {
        console.error('Error al obtener las cuentas:', error)
      }
    }

    fetchData()
  }, [Id, nameregion, Type, tenant, currentUser])

  useEffect(() => {
    if (Id && Type) {
      if (
        typeof Id === 'number' &&
        ![0, -1].includes(Id) &&
        Type === 'CloudGlobal' &&
        tenant === 0
      ) {
        getCTXRStatus(Id).then((response) => {
          if (response.data && response.data.error === 'suscriptionId error') {
            setstatusCTX([])
          } else {
            setstatusCTX(response.data)
          }
        })
      } else if (
        typeof Id === 'number' &&
        ![0, -1].includes(Id) &&
        Type === 'CloudGlobal' &&
        tenant !== 0 &&
        currentUser?.ListPermiso?.includes('CTXR.GeneralStatus')
      ) {
        getCTXRStatusGlobal(Id, tenant).then((response) => {
          if (response.data && response.data.error === 'suscriptionId error') {
            setstatusCTX([])
          } else {
            setstatusCTX(response.data)
          }
        })
      }
    }
  }, [Id, Type, nameregion, tenant, currentUser])

  const formatKey = (key: string): string => {
    return key
      .replace(/_/g, ' ')
      .replace(/\b\w/g, (char) => char.toUpperCase())
  }

  return (
    <div className={`card ${className}`}>
      {/* begin::Header */}
      <div className='card-header border-0 pt-5'>
        <h3 className='card-title align-items-start flex-column'>
          <span className='card-label fw-bold fs-3 mb-1'>Instances Status</span>
        </h3>
      </div>
      {/* end::Header */}
      {/* begin::Body */}
      <div className='card-body py-3'>
        <div className='tab-content'>

          {statusCTX.length > 0 && (
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px', marginRight: '5px' }}>
              <div>
                <span className="text-marino f-parrafo fw-semibold">
                  Total Records: {totalItems}
                </span>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', height: '30px' }}>
                <div className="input-group custom-search-group" style={{ display: 'flex', height: '30px' }}>
                  <span
                    className="input-group-text"
                    style={{
                      justifyContent: 'center',
                      height: '30px',
                      lineHeight: '30px',
                      padding: '0 8px'
                    }}
                  >
                    <i
                      className="bi-search"
                      style={{ fontSize: '1rem', color: '#FF4089', verticalAlign: 'middle' }}
                    ></i>
                  </span>
                  <select
                    className="form-select"
                    style={{
                      border: '1px solid var(--bs-gray-300)',
                      width: '120px',
                      height: '30px',
                      lineHeight: '30px',
                      padding: '0 8px',
                      fontSize: '0.875rem'
                    }}
                    value={searchColumn}
                    onChange={(e) => { setSearchColumn(e.target.value); setCurrentPage(1); }}
                  >
                    <option value="All">All</option>
                    <option value="name">Name</option>
                    <option value="description">Description</option>
                    <option value="region">Region</option>
                    <option value="status">Status</option>
                    <option value="version">Version</option>
                  </select>
                  <input
                    type="text"
                    className="form-control"
                    style={{
                      width: '150px',
                      height: '30px',
                      lineHeight: '30px',
                      padding: '0 8px',
                    }}
                    placeholder={`Search by ${searchColumn === 'All' ? 'All' : searchColumn}`}
                    value={searchTerm}
                    onChange={handleSearchChange}
                  />
                </div>
              </div>
            </div>
          )}

          <div className='tab-pane fade show active' id='kt_table_widget_6_tab_1'>
            <div className='table-responsive'>
              {statusCTX.length === 0 ? (
                <div className='no-data-message'>No Data Available</div>
              ) : (
                <>
                  <table className='w-full f-parrafo caption-bottom custom-table'>
                    <thead>
                      <tr className="text-azul text-left">
                        <th
                          className="table-cell"
                          onClick={() => handleSort('name')}
                          style={{ cursor: 'pointer' }}
                        >
                          <div className={styles['header-content']}>
                            <span>CTX-R Name</span>
                            <span className={styles['sortable-column']}>
                              {getSortIcon('name')}
                            </span>
                          </div>
                        </th>
                        <th
                          className="table-cell"
                          onClick={() => handleSort('description')}
                          style={{ cursor: 'pointer' }}
                        >
                          <div className={styles['header-content']}>
                            <span>Description</span>
                            <span className={styles['sortable-column']}>
                              {getSortIcon('description')}
                            </span>
                          </div>
                        </th>
                        <th
                          className="table-cell"
                          onClick={() => handleSort('region')}
                          style={{ cursor: 'pointer' }}
                        >
                          <div className={styles['header-content']}>
                            <span>Region</span>
                            <span className={styles['sortable-column']}>
                              {getSortIcon('region')}
                            </span>
                          </div>
                        </th>
                        <th
                          className="table-cell"
                          onClick={() => handleSort('status')}
                          style={{ cursor: 'pointer' }}
                        >
                          <div className={styles['header-content']}>
                            <span>Status</span>
                            <span className={styles['sortable-column']}>
                              {getSortIcon('status')}
                            </span>
                          </div>
                        </th>
                        <th
                          className="table-cell"
                          onClick={() => handleSort('version')}
                          style={{ cursor: 'pointer' }}
                        >
                          <div className={styles['header-content']}>
                            <span>Version</span>
                            <span className={styles['sortable-column']}>
                              {getSortIcon('version')}
                            </span>
                          </div>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {paginatedData.map((d, i) => (
                        <tr key={i} className='table-row'>
                          <td className='table-cell'>{d.name}</td>
                          <td className='table-cell'>{d.description}</td>
                          <td className='table-cell'>{d.region}</td>
                          <td className={`table-cell ${styles['mid-row']}`}>{renderStatusIcon(d.lastupdate)}</td>
                          <td className={`table-cell ${styles['mid-row']}`}>
                            {d.version ? (
                              <span
                                onClick={() => handleVersionClick(d.metadata, d.name)}
                                style={{ cursor: 'pointer', color: '#0d6efd', fontWeight: 'bold' }}
                              >
                                {d.version}
                              </span>
                            ) : (
                              <OverlayTrigger
                                placement="top"
                                overlay={
                                  <Tooltip id={`tooltip-${i}`}>
                                    Contact CTX Support for guidance on what to do next.
                                  </Tooltip>
                                }
                              >
                                <span style={{ cursor: 'pointer' }}>
                                  <KTIcon iconName="bi bi-info-circle" className={`${styles.infoIconColor} fs-3`} />
                                </span>
                              </OverlayTrigger>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>

                  {filteredData.length > 0 && (
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '10px' }}>
                      <div>
                        {currentPage > 1 && (
                          <button
                            onClick={() => handlePageChange(currentPage - 1)}
                            className={`btn btn-secondary ${styles.buttonRows}`}
                          >
                            Previous
                          </button>
                        )}
                      </div>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <span>Page {currentPage} of {totalPages}</span>
                      </div>
                      <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                        {currentPage < totalPages && (
                          <button
                            onClick={() => handlePageChange(currentPage + 1)}
                            className={`btn btn-secondary ${styles.buttonRows}`}
                          >
                            Next
                          </button>
                        )}

                        <div className={`select-container ${styles.selectContainer}`}>
                          <select
                            className={`custom-select aligned-select text-center ${styles.selectStyle}`}
                            aria-label="Select items per page"
                            value={itemsPerPage}
                            onChange={(e) => {
                              setItemsPerPage(Number(e.target.value))
                              setCurrentPage(1)
                            }}
                          >
                            <option value={5}>5 rows</option>
                            <option value={10}>10 rows</option>
                            <option value={20}>20 rows</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </div>

      <Modal
        show={showModal}
        onHide={handleCloseModal}
        size='lg'
        dialogClassName='custom-modal'
      >
        <Modal.Header closeButton>
          <Modal.Title>{selectedName} Details</Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{
            padding: '1.5rem',
            border: 'none',
            boxShadow: 'none',
          }}
        >
          {selectedMetadata ? (
            <div style={{ fontSize: '1.2em', lineHeight: '1.6' }}>
              {Object.entries(selectedMetadata).map(([key, value]) => (
                <div
                  key={key}
                  style={{
                    marginBottom: '1em',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                  }}
                >
                  <div>
                    <strong>{formatKey(key)}:</strong>{' '}
                    <span style={{ color: '#333' }}>{value}</span>
                  </div>
                  <CopyToClipboard text={String(value)} onCopy={() => handleCopy(String(value), key)}>
                    <button
                      className='btn btn-light btn-sm'
                      style={{ display: 'flex', alignItems: 'center' }}
                    >
                      <KTIcon iconName='copy' className='fs-2 me-1' />
                      {copiedKey === key ? 'Copied!' : 'Copy'}
                    </button>
                  </CopyToClipboard>
                </div>
              ))}
            </div>
          ) : (
            <p>No metadata available.</p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <button className='btn btn-secondary' onClick={handleCloseModal}>
            Close
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  )
}

const renderStatusIcon = (status: string) => {
  switch (status.toLowerCase()) {
    case 'up':
      return <KTIcon iconName='bi bi-check-circle' className='text-success fs-1' />
    case 'down':
      return <KTIcon iconName='bi bi-x-circle' className='text-danger fs-1' />
    case 'no data':
      return <KTIcon iconName='bi bi-exclamation-triangle' className='text-warning fs-1' />
    default:
      return null
  }
}

export { TablesWidget6 }
